module.exports = __webpack_public_path__ + "img/1476333458.2ef170e8.jpg";